import React, { useEffect, useState } from "react";
import {
  FaBrain,
  FaClock,
  FaFilePen,
  FaShieldHalved,
  FaUsersViewfinder,
} from "react-icons/fa6";
import { FaEraser } from "react-icons/fa";
import { FaRegCheckCircle } from "react-icons/fa";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
import "./style.css";
import { URL } from "screen/00_Nav/url";
import NavbarAction from "./component/navbar_action";
import ButtonCta from "./component/button_cta";
import ButtonTryPlatform from "./component/button_try_platform";
import SEOHelmet from "component/seo/seo_helmet";
import logo from "asset/img/logo/client.png";

const HomeScreen = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  const [displayText, setDisplayText] = useState("");
  const [bars, setBars] = useState([]);
  const textToType =
    " Tại địa chỉ số 105 Đường Giải Phóng, chúng tôi ghi nhận hiện trạng...";
  const colors = ["bg-primary-700", "bg-primary-500", "bg-accent-500"];
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    let typeIndex = -1;
    let timer;

    const typeWriter = () => {
      if (typeIndex < textToType.length) {
        // Sử dụng functional update để lấy giá trị text mới nhất
        setDisplayText((prev) => prev + textToType.charAt(typeIndex));
        typeIndex++;
        timer = setTimeout(typeWriter, 40);
      } else {
        // Đợi 4s rồi reset
        timer = setTimeout(() => {
          setDisplayText("");
          typeIndex = 0;
          typeWriter();
        }, 4000);
      }
    };

    typeWriter();

    // Cleanup function để tránh memory leak khi component bị unmount
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const newBars = Array.from({ length: 20 }).map(() => ({
      color: colors[Math.floor(Math.random() * colors.length)],
      height: Math.random() * 60 + 20 + "%",
      duration: Math.random() * 0.5 + 0.6 + "s",
    }));
    setBars(newBars);
  }, []);
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderNavbar = () => {
    return (
      <nav className="fixed z-50 w-full border-b border-white/10 bg-primary-900 transition-all duration-300">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-20 items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="flex h-10 items-center justify-center rounded-full p-1 shadow-lg">
                <img
                  className="h-[50px] w-auto rounded-full bg-white"
                  src={logo}
                  alt="logo"
                />
              </div>

              <div className="flex flex-col">
                <span className="font-heading text-xl font-bold tracking-wide text-white">
                  Dịch Vụ Chuyển Âm{" "}
                  <span className="text-accent-500">Support</span>
                </span>
                <span className="text-xs uppercase tracking-wider text-gray-400">
                  Hỗ trợ nghiệp vụ
                </span>
              </div>
            </div>

            <div className="hidden md:block">
              <div className="ml-10 flex items-center space-x-4">
                <NavbarAction />
              </div>
            </div>
          </div>
        </div>
      </nav>
    );
  };

  const renderHeroSection = () => {
    return (
      <section className="relative flex min-h-screen items-center overflow-hidden bg-gradient-to-br from-primary-900 to-primary-700 pb-20 pt-20">
        <div
          className="absolute inset-0 z-0 opacity-10"
          style={{
            backgroundImage: `url(
              "data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='#ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E",
            )`,
          }}
        ></div>

        <div className="relative z-10 mx-auto grid max-w-7xl items-center gap-16 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
          <div className="animate-fade-in-up mt-5 space-y-8 lg:mt-0">
            <div className="inline-flex items-center gap-2 rounded-full border border-accent-500/30 bg-accent-500/10 px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-accent-500">
              <span className="h-2 w-2 animate-pulse rounded-full bg-accent-500"></span>
              Dành riêng cho Dịch Vụ Chuyển Âm
            </div>

            <h1 className="font-heading text-5xl font-bold leading-[1.15] text-white md:text-6xl">
              AI Chuyển File <br />
              Âm Thanh Thành <br />
              <span className="relative inline-block text-accent-500">
                File Word
                <svg
                  className="absolute bottom-1 left-0 h-2 w-full text-accent-500 opacity-60"
                  viewBox="0 0 100 10"
                  preserveAspectRatio="none"
                >
                  <path
                    d="M0 5 Q 50 10 100 5"
                    stroke="currentColor"
                    stroke-width="3"
                    fill="none"
                  />
                </svg>
              </span>
            </h1>

            <p className="max-w-lg text-lg font-light leading-relaxed text-gray-300">
              Nhanh chóng hoàn thành Vi Bằng cho file âm thanh. Upload file và
              AI của chúng tôi sẽ chuyển âm với hiệu suất ấn tượng. Việc của bạn
              chỉ cần xem lại file Word với các công cụ hỗ trợ hiện đại.
            </p>

            <div className="flex flex-col gap-4 pt-2 sm:flex-row">
              <ButtonCta />
            </div>
          </div>

          <div className="group relative">
            <div className="relative flex min-h-[480px] flex-col overflow-hidden rounded-2xl border border-neutral-100 bg-white shadow-2xl">
              <div className="flex items-center justify-between border-b border-primary-700 bg-primary-900 px-5 py-3">
                <div className="flex gap-2">
                  <div className="h-3 w-3 rounded-full bg-red-500"></div>
                  <div className="h-3 w-3 rounded-full bg-yellow-500"></div>
                  <div className="h-3 w-3 rounded-full bg-green-500"></div>
                </div>
                <div className="font-mono text-[10px] text-gray-400">
                  SESSION: VB-2023-10-24
                </div>
              </div>

              <div className="flex h-full flex-1 flex-col bg-neutral-50">
                <div className="flex items-center justify-center border-b border-neutral-200 bg-white p-8">
                  <div className="mb-4 flex h-20 items-center justify-center gap-1">
                    {bars.map((bar, index) => (
                      <div
                        key={index}
                        className={`w-1.5 ${bar.color} animate-wave rounded-full`}
                        style={{
                          height: bar.height,
                          animationDuration: bar.duration,
                        }}
                      />
                    ))}
                  </div>
                </div>

                <div className="relative w-full flex-1 p-8 font-mono text-sm leading-7 text-neutral-600 md:w-[700px] lg:w-[500px]">
                  <div className="absolute right-4 top-2 rounded bg-accent-200/50 px-2 py-1 text-[10px] font-bold text-accent-500">
                    PROCESSING
                  </div>

                  <div className="space-y-4">
                    <p>
                      <span className="font-bold text-primary-500">
                        [Người nói 1]: <span>(00h.03m.00s)</span>
                      </span>{" "}
                      <span
                        className="typing-cursor text-neutral-900"
                        id="typingText"
                      >
                        {displayText}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="absolute -right-10 top-10 -z-10 h-full w-full rounded-2xl bg-primary-500/10 blur-2xl"></div>
          </div>
        </div>
      </section>
    );
  };

  const renderSolution = () => {
    return (
      <section id="giai-phap" className="relative bg-white py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="mb-16 text-center">
            <span className="mb-2 block text-sm font-bold uppercase tracking-wider text-primary-500">
              Giải Pháp Toàn Diện
            </span>
            <h2 className="mb-4 max-w-[1200px] text-3xl font-bold text-primary-900 md:text-4xl">
              Đây là giải pháp chuyển âm <br /> kết hợp Chỉnh sửa nội dung Vi
              Bằng chuyên nghiệp
              <br />
            </h2>
          </div>

          <div className="grid gap-8 md:grid-cols-3">
            <div className="group rounded-2xl border border-neutral-100 bg-white p-8 shadow-card transition-all duration-300 hover:-translate-y-1 hover:shadow-xl">
              <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-xl bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-700 group-hover:text-white">
                <FaUsersViewfinder className="text-2xl" />
              </div>
              <h3 className="mb-3 text-xl font-bold text-primary-900">
                Định Danh Người Nói
              </h3>
              <p className="text-sm leading-relaxed text-neutral-600">
                AI sẽ hỗ trợ tách biệt giọng nói xuất hiện trong file âm thanh
                và định dạng văn bản tuần tự theo thứ tự người nói theo file.
              </p>
            </div>

            <div className="group rounded-2xl border border-neutral-100 bg-white p-8 shadow-card transition-all duration-300 hover:-translate-y-1 hover:shadow-xl">
              <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-xl bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-700 group-hover:text-white">
                <FaClock className="text-2xl" />
              </div>
              <h3 className="mb-3 text-xl font-bold text-primary-900">
                Time-stamp Chính Xác
              </h3>
              <p className="text-sm leading-relaxed text-neutral-600">
                Thời gian của các đoạn hội thoại cho từng người nói sẽ được gán
                nhãn chính xác. Nền tảng hỗ trợ kiểm tra lại với file gốc trực
                tiếp.
              </p>
            </div>

            <div className="group rounded-2xl border border-neutral-100 bg-white p-8 shadow-card transition-all duration-300 hover:-translate-y-1 hover:shadow-xl">
              <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-xl bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-700 group-hover:text-white">
                <FaFilePen className="text-2xl" />
              </div>
              <h3 className="mb-3 text-xl font-bold text-primary-900">
                Chỉnh Sửa Nhanh Chóng
              </h3>
              <p className="text-sm leading-relaxed text-neutral-600">
                Các công cụ hỗ trợ kiểm tra nội dung và chỉnh sửa thành quả sẽ
                được tích hợp để bạn kiểm tra lần cuối nhanh chóng, dễ dàng. Sau
                khi tải về , dữ liệu và kết quả sẽ tự động bị xóa khỏi hệ thống.
              </p>
            </div>
          </div>
        </div>
      </section>
    );
  };

  const renderPlatform = () => {
    return (
      <section
        id="nen-tang"
        className="relative overflow-hidden bg-primary-100 py-24"
      >
        <div className="absolute right-0 top-0 -mr-20 -mt-20 h-96 w-96 rounded-full bg-accent-200/40 blur-3xl"></div>
        <div className="bg-primary-200/40 absolute bottom-0 left-0 -mb-20 -ml-20 h-80 w-80 rounded-full blur-3xl"></div>

        <div className="relative z-10 mx-auto max-w-5xl px-4 text-center">
          <div className="rounded-3xl border border-primary-100 bg-white p-10 shadow-2xl md:p-16">
            <span className="mb-4 block text-xs font-bold uppercase tracking-widest text-primary-500">
              Trải Nghiệm Ngay
            </span>

            <h2 className="mb-6 font-heading text-2xl font-bold leading-tight text-primary-900 md:text-5xl">
              Sẵn sàng trải nghiệm dịch vụ{" "}
              <span className="text-primary-700">Chuyển Âm thành Vi Bằng</span>{" "}
              nhanh chóng?
            </h2>

            <p className="mx-auto mb-10 max-w-2xl text-lg text-neutral-600">
              Rút ngắn công việc từ vài tuần còn vài ngày, tại sao không?
            </p>

            <ButtonTryPlatform />

            <p className="mt-6 flex flex-col justify-center gap-3 text-sm text-neutral-500 md:flex-row">
              <FaRegCheckCircle className="mr-2 text-accent-500" />
              Không cần cài đặt
              <span className="mx-2 hidden md:block">•</span>
              <FaRegCheckCircle className="mr-2 text-accent-500" />
              Bảo mật dữ liệu
            </p>
          </div>
        </div>
      </section>
    );
  };

  const renderSecurity = () => {
    return (
      <section
        id="bao-mat"
        className="border-t border-neutral-100 bg-white py-20"
      >
        <div className="mx-auto flex max-w-4xl flex-col justify-center px-4 text-center">
          <FaShieldHalved className="mb-4 text-4xl text-primary-500" />
          <h2 className="mb-6 text-2xl font-bold text-primary-900">
            Cam Kết Bảo Mật Tuyệt Đối
          </h2>
          <div className="mt-10 grid gap-6 text-left md:grid-cols-2">
            <div className="rounded-xl border border-neutral-100 bg-neutral-50 p-6">
              <h4 className="mb-2 flex items-center gap-2 font-bold text-primary-900">
                <FaEraser className="text-accent-500" /> Xóa dữ liệu tự động
              </h4>
              <p className="text-sm text-neutral-600">
                Sau khi tải về, dữ liệu và kết quả sẽ tự động bị xóa vĩnh viễn
                khỏi hệ thống.
              </p>
            </div>
            <div className="rounded-xl border border-neutral-100 bg-neutral-50 p-6">
              <h4 className="mb-2 flex items-center gap-2 font-bold text-primary-900">
                <FaBrain className="text-accent-500" /> Không huấn luyện ngược
              </h4>
              <p className="text-sm text-neutral-600">
                Dữ liệu của văn phòng KHÔNG bao giờ được dùng để huấn luyện lại
                mô hình AI.
              </p>
            </div>
          </div>
        </div>
      </section>
    );
  };

  const renderFooter = () => {
    return (
      <footer className="border-t border-white/5 bg-primary-900 py-12 text-white">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 px-4 sm:px-6 md:flex-row lg:px-8">
          <div className="flex items-center gap-3">
            <img
              className="h-[50px] w-auto rounded-full bg-white"
              src={logo}
              alt="logo"
            />
            <span className="font-heading text-xl font-bold">
              Dịch Vụ Chuyển Âm Support
            </span>
          </div>

          <div className="flex flex-col gap-6 text-center text-sm text-gray-400 md:flex-row md:gap-8 md:text-left">
            <a href={URL.term} className="transition-colors hover:text-white">
              Điều khoản sử dụng
            </a>
            <a
              href={URL.privacy}
              className="transition-colors hover:text-white"
            >
              Chính sách bảo mật
            </a>
          </div>

          <div className="text-xs text-gray-500">
            &copy; 2025 Legal Tech Solutions. All rights reserved.
          </div>
        </div>
      </footer>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <div className="overflow-x-hidden font-body antialiased">
      {renderNavbar()}
      {renderHeroSection()}
      {renderSolution()}
      {renderPlatform()}
      {renderSecurity()}
      {renderFooter()}
      <SEOHelmet />
    </div>
  );
};
export default HomeScreen;
